<script>
  import { ignore } from "../../Common/tools";
  import ColorPicker from "../../Common/ColorPicker.svelte";
  import Slider from "../../Common/Slider.svelte";
  import {M} from "../../external";

  export let widget,
    onChange = ignore;
  let data = widget.data,
    widgetUi = widget.$widget;
</script>

<div class="popup-widget-wrapper">
  <div class="input-wrapper col20 f-left color-pick-wrap-widgets">
    <ColorPicker bind:color={data.bgColor} bind:colorClass={data.bgColorClass} label={M.BACKGROUND_COLOR} onChange={onChange} />
  </div>

  <div class="input-wrapper col20 f-left color-pick-wrap-widgets">
    <ColorPicker bind:color={data.activeColor} bind:colorClass={data.activeColorClass} label={M.ACTIVE_COLOR} onChange={onChange} />
  </div>

  <div class="input-wrapper col20 f-left">
    <Slider bind:value={data.padding} min={0} max={100} label={M.FORM_PADDING} onChange={onChange} />
  </div>
</div>
